'use client';

import { motion } from 'framer-motion';

export const MotionH1 = motion.h1;
